import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: { title: '首页', icon: 'home' },
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '仪表盘', icon: 'dashboard' }
    },


    ]
  }
]

export const asyncRouterMap = [

  // {
  //   path: '/article',
  //   component: Layout,
  //   name: 'article',
  //   redirect: '/article/index',
  //   meta: { title: '文章管理' },
  //   // component: () => import('@/views/article/index'),
  //   children: [
  //     {
  //       path: 'articleindex',
  //       name: 'articleindex',
  //       component: () => import('@/views/article/index'),
  //       meta: { title: '文章管理' }
  //     },
  //     {
  //       path: 'articlelist',
  //       name: 'articlelist',
  //       component: () => import('@/views/article/list'),
  //       meta: { title: '文章列表' }
  //     },
  //     {
  //       path: 'u-parse-preview',
  //       name: 'uParsePreview',
  //       component: () => import('@/views/edit/u-parse-preview'),
  //       meta: { title: 'u-parse 预览', icon: 'edit' }
  //     },
  //     // getArticleListks
  //     {
  //       path: 'articlelistks',
  //       name: 'articlelistks',
  //       component: () => import('@/views/edit/list'),
  //       meta: { title: '自定页面' }
  //     },
  //     {
  //       path: 'u-parse-preview-h5',
  //       name: 'uParsePreviewH5',
  //       component: () => import('@/views/edit/u-parse-preview-h5'),
  //       meta: { title: 'u-parse H5 预览', icon: 'edit' }
  //     },
  //   ]
  // },
  // 自定页面
  {
    path: '/edit',
    component: Layout,
    redirect: '/edit/articlelistks',
    name: 'config',
    meta: { title: '系统设置类', icon: 'edit' },
    children: [
      {
        path: 'articleindex',
        name: 'articleindex',
        component: () => import('@/views/article/index'),
        meta: { title: '文章管理' }
      },
      {
        path: 'articlelist',
        name: 'articlelist',
        component: () => import('@/views/article/list'),
        meta: { title: '文章列表' }
      },
      {
        path: 'u-parse-preview',
        name: 'uParsePreview',
        component: () => import('@/views/edit/u-parse-preview'),
        meta: { title: 'u-parse 预览', icon: 'edit' }
      },
      // getArticleListks
      {
        path: 'editlist',
        name: 'editlist',
        component: () => import('@/views/edit/list'),
        meta: { title: '自定页面' }
      },
      {
        path: 'u-parse-preview-h5',
        name: 'uParsePreviewH5',
        component: () => import('@/views/edit/u-parse-preview-h5'),
        meta: { title: 'u-parse H5 预览', icon: 'edit' }
      },
      {
        path: 'list',
        name: 'plateList',
        component: () => import('@/views/plate/list'),
        meta: { title: '板块列表', icon: 'plate-list' }
      },
      {
        path: 'index',
        name: 'commentList',
        component: () => import('@/views/comment/index'),
        meta: { title: '评论列表', icon: 'el-icon-chat-line-round' }
      },

      {
        path: 'detail/:id',
        name: 'commentDetail',
        component: () => import('@/views/comment/detail'),
        meta: { title: '评论详情' },
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: { title: '商品分类', icon: 'product-cate' }
      },
      {
        path: 'adminLog',
        name: 'adminLog',
        component: () => import('@/views/system/adminLog/index'),
        meta: { title: '操作日志', icon: 'el-icon-document' }
      },
      {
        path: 'log',
        name: 'log',
        component: () => import('@/views/log/index.vue'),
        meta: { title: '操作日志', icon: 'el-icon-document' }
      },
      {
        path: 'pickupPointIndex',
        name: 'pickupPointIndex',
        component: () => import('@/views/pickupPoint/index'),
        meta: { title: '自提点管理', icon: 'product-list' }
      },
      {
        path: 'phones',
        name: 'phones',
        component: () => import('@/views/activity/Phones/index'),
        meta: { title: '短信内容管理', icon: 'sms-phone' }
      },
    ]
  },
  {
    path: '/configActive',
    component: Layout,
    redirect: '/edit/articlelistks',
    name: 'configActive',
    meta: { title: '活动', icon: 'edit' },
    children: [
      {
        path: 'index',
        name: 'productCommission',
        component: () => import('@/views/sales/index'),
        meta: { title: '商品分销设置', icon: 'product-list' }
      },
      {
        path: '/chicken',
        component: Layout,
        redirect: '/chicken/index',
        name: 'chicken',
        meta: { title: '饲料任务管理', icon: 'el-icon-s-help' },
        children: [{
          path: 'index',
          name: 'chickenIndex',
          component: () => import('@/views/chicken/index'),
          meta: { title: '饲料规则管理', icon: 'el-icon-document' }
        },
        {
          path: 'claim-record',
          name: 'chickenClaimRecord',
          component: () => import('@/views/chicken/claimRecord'),
          meta: { title: '领取记录', icon: 'el-icon-document' }
        },
        {
          path: "linkSetting",
          name: "LinkSetting",
          component: () => import("@/views/chicken/linkSetting"),
          meta: { title: "今日特惠", icon: "el-icon-link" }
        },
        {
          path: 'test',
          name: 'chickenTest',
          component: () => import('@/views/chicken/test'),
          meta: { title: '功能测试', icon: 'el-icon-s-operation' },
          hidden: true
        },
        {
          path: 'router-test',
          name: 'chickenRouterTest',
          component: () => import('@/views/chicken/router-test'),
          meta: { title: '路由测试', icon: 'el-icon-s-operation' },
          hidden: true
        }
        ]
      },
      {
        path: '/plant',
        component: Layout,
        redirect: '/plant/index',
        name: 'plant',
        meta: { title: '养殖饲料奖励管理', icon: 'el-icon-s-help' },
        children: [{
          path: 'index',
          name: 'plantIndex',
          component: () => import('@/views/plant/index'),
          meta: { title: '饲料规则管理', icon: 'el-icon-document' }
        },
        {
          path: 'userReward',
          name: 'plantUserReward',
          component: () => import('@/views/plant/claimRecord'),
          meta: { title: '用户奖励记录', icon: 'el-icon-user' }
        }
        ]
      },
      {
        path: 'activity',
        name: 'luckActivity',
        component: () => import('@/views/luck/index.vue'),
        meta: { title: '抽奖活动管理', icon: 'gift' }
      },
      {
        path: '/activity',
        component: Layout,
        name: 'activity',
        redirect: '/activity/index',
        meta: { title: '营销活动商品管理', icon: 'product' },
        children: [
          {
            path: 'index',
            name: 'marketingActivityProduct',
            component: () => import('@/views/activity/index'),
            meta: { title: '营销活动商品管理', icon: 'product-list' }
          },
          {
            path: 'activityManage',
            name: 'activityProductCombined',
            component: () => import('@/views/activity/activityManage'),
            meta: { title: '阶段活动管理', icon: 'gift' }
          },
          // bargain
          // unite
          {
            path: 'unite',
            name: 'unite',
            component: () => import('@/views/unite/index'),
            meta: { title: '联合活动管理', icon: 'gift' }
          }, {
            path: 'bargain',
            name: 'bargain',
            component: () => import('@/views/bargain/index'),
            meta: { title: '砍价活动管理', icon: 'gift' }
          },
          {
            path: 'order-manage',

            component: () => import('@/views/activity/ActivityOrderManage'),
            name: 'ActivityOrderManage',
            meta: { title: '活动订单管理', icon: 'order' }
          },
          {
            path: 'order-info',
            component: () => import('@/views/feed/order/orderDetail'),

            // component: () => import('@/views/activity/ActivityOrderInfo'),
            name: 'ActivityOrderInfo',
            meta: { title: '活动订单详情', icon: 'order' }
          },
          {
            path: 'activityTest',
            name: 'activityProductCombinedTest',
            component: () => import('@/views/activity/activityTest'),
            meta: { title: '活动管理测试', icon: 'test' },
            hidden: true
          },
          {
            path: 'buyingGroupPrice',
            name: 'buyingGroupPrice',
            component: () => import('@/views/activity/Buying/index'),
            meta: { title: '拼团价格管理', icon: 'gift' }
          },
          {
            path: 'buyingGroupParticipants',
            name: 'buyingGroupParticipants',
            component: () => import('@/views/buyingGroup/participants'),
            meta: { title: '拼团参团信息', icon: 'el-icon-s-custom' },
            hidden: true
          },
          {
            path: 'oneYuanActivityManage',
            name: 'oneYuanActivityManage',
            component: () => import('@/views/activity/oneYuanActivityManage'),
            meta: { title: '一元购活动管理', icon: 'gift' }
          },
          {
            path: 'addOneYuanActivity',
            name: 'addOneYuanActivity',
            component: () => import('@/views/activity/oneYuanActivityEdit'),
            meta: { title: '添加一元购活动', icon: 'edit' },
            hidden: true
          },
          {
            path: 'updateOneYuanActivity',
            name: 'updateOneYuanActivity',
            component: () => import('@/views/activity/oneYuanActivityEdit'),
            meta: { title: '编辑一元购活动', icon: 'edit' },
            hidden: true
          },
          {
            path: 'test',
            name: 'marketingActivityProductTest',
            component: () => import('@/views/activity/test'),
            meta: { title: '功能测试', icon: 'test' },
            hidden: true
          }
        ],

      },
      {
        path: '/share',
        component: Layout,
        name: 'share',
        redirect: '/share/index',
        meta: { title: '芮分享', icon: 'product' },
        children: [
          {
            path: 'taskIndex',
            name: 'index',
            component: () => import('@/views/share/task/index'),
            meta: { title: '分享列表', icon: 'product-list' }
          },
          {
            path: 'addTask',
            name: 'shareAddTask',
            component: () => import('@/views/share/task/add'),
            meta: { title: '分享添加', icon: 'product-list' },
            hidden: true
          },
          {
            path: 'editTask',
            name: 'shareEditTask',
            component: () => import('@/views/share/task/edit'),
            meta: { title: '分享编辑', icon: 'product-list' },
            hidden: true
          },
          {
            path: 'auditIndex',
            name: 'auditIndex',
            component: () => import('@/views/share/log/audit'),
            meta: { title: '分享审核', icon: 'order-list' }
          },
        ]
      },
      {
        path: '/points',
        component: Layout,
        redirect: '/points/product',
        name: 'points',
        meta: { title: '积分商城', icon: 'product' },
        children: [
          {
            path: 'zbproduct',
            name: 'zbpointsProduct',
            component: () => import('@/views/points/product/index'),
            meta: { title: '总部商品管理', icon: 'product-list' },
            props: (route) => ({ type: route.query.type || 11 })
          },
          {
            path: 'pjproduct',
            name: 'pjpointsProduct',
            component: () => import('@/views/points/product/index'),
            meta: { title: '平价商品管理', icon: 'product-list' },
            props: (route) => ({ type: route.query.type || 12 })
          },
          {
            path: 'product',
            name: 'pointsProduct',
            component: () => import('@/views/points/product/index'),
            meta: { title: '酒业商品管理', icon: 'product-list' },
            props: (route) => ({ type: route.query.type || 1 })
          }, {
            path: 'jqproduct',
            name: 'jqpointsProduct',
            component: () => import('@/views/points/product/index'),
            meta: { title: '景区商品管理', icon: 'product-list' },
            props: (route) => ({ type: route.query.type || 3 })
          }, {
            path: 'nmproduct',
            name: 'nmpointsProduct',
            component: () => import('@/views/points/product/index'),
            meta: { title: '农贸商品管理', icon: 'product-list' },
            props: (route) => ({ type: route.query.type || 5 })
          }, {
            path: 'slproduct',
            name: 'slpointsProduct',
            component: () => import('@/views/points/product/index'),
            meta: { title: '饲料商品管理', icon: 'product-list' },
            props: (route) => ({ type: route.query.type || 7 })
          }, {
            path: 'tjproduct',
            name: 'tjpointsProduct',
            component: () => import('@/views/points/product/index'),
            meta: { title: '体检商品管理', icon: 'product-list' },
            props: (route) => ({ type: route.query.type || 8 })
          }, {
            path: 'order',
            name: 'pointsOrder',
            component: () => import('@/views/points/order/index'),
            meta: { title: '酒业订单管理', icon: 'order-list' },
            props: (route) => ({ type: route.query.type || 1 })

          }, {
            path: 'jqorder',
            name: 'jqpointsOrder',
            component: () => import('@/views/points/order/index'),
            meta: { title: '景区订单管理', icon: 'order-list' },
            props: (route) => ({ type: route.query.type || 3 })
          }, {
            path: 'nmorder',
            name: 'nmpointsOrder',
            component: () => import('@/views/points/order/index'),
            meta: { title: '农贸订单管理', icon: 'order-list' },
            props: (route) => ({ type: route.query.type || 5 })
          }, {
            path: 'slorder',
            name: 'slpointsOrder',
            component: () => import('@/views/points/order/index'),
            meta: { title: '饲料订单管理', icon: 'order-list' },
            props: (route) => ({ type: route.query.type || 7 })
          }, {
            path: 'tjorder',
            name: 'tjpointsOrder',
            component: () => import('@/views/points/order/index'),
            meta: { title: '体检订单管理', icon: 'order-list' },
            props: (route) => ({ type: route.query.type || 8 })
          }, {
            path: 'zborder',
            name: 'zbpointsOrder',
            component: () => import('@/views/points/order/index'),
            meta: { title: '总部订单管理', icon: 'order-list' },
            props: (route) => ({ type: route.query.type || 11 })
          },
          {
            path: 'pjorder',
            name: 'pjpointsOrder',
            component: () => import('@/views/points/order/index'),
            meta: { title: '平价订单管理', icon: 'order-list' },
            props: (route) => ({ type: route.query.type || 12 })
          }]
      },
    ]
  },
  {
    path: '/money',
    component: Layout,
    name: 'money',
    redirect: '/money/list',
    meta: { title: '活动类', icon: 'plate' },
    children: [
      {
        path: '/wallet',
        component: Layout,
        redirect: '/wallet/list',
        name: 'wallenamet',
        meta: { title: '钱包管理', icon: 'wallet' },
        children: [
          {
            path: 'list',
            name: 'WalletList',
            component: () => import('@/views/catering/wallet-list'),
            meta: { title: '餐饮钱包管理', icon: 'wallet-list' },
            props: (route) => ({ type: 5 })
          },
          // 1-长城钱包 2-兴芮钱包 3-文库钱包 
          {
            path: 'list-cc',
            name: 'WalletListgwm',
            component: () => import('@/views/catering/wallet-list'),
            meta: { title: '长城钱包管理', icon: 'wallet-list' },
            props: (route) => ({ type: 1 })
          },
          {
            path: 'list-xr',
            name: 'WalletListxr',
            component: () => import('@/views/catering/wallet-list'),
            meta: { title: '兴芮钱包管理', icon: 'wallet-list' },
            props: (route) => ({ type: 2 })
          }, {
            path: 'list-wl',
            name: 'WalletListwl',
            component: () => import('@/views/catering/wallet-list'),
            meta: { title: '文旅钱包管理', icon: 'wallet-list' },
            props: (route) => ({ type: 3 })
          },
        ]
      },
      {
        path: '/score',
        component: Layout,
        name: 'score',
        redirect: '/score/scoreCategory',
        meta: { title: '对账管理', icon: 'product' },
        children: [
          {
            path: 'category',
            name: 'scoreCategory',
            component: () => import('@/views/score/index'),
            meta: { title: '分类汇总', icon: 'product-list' }
          },
          {
            path: 'list',
            name: 'scoreList',
            component: () => import('@/views/score/list'),
            meta: { title: '对账列表', icon: 'product-list' }
          },
          {
            path: 'scoreByCategory',
            name: 'scoreByCategory',
            component: () => import('@/views/kppoint/scoreByCategory'),
            meta: { title: '积分商城对账', icon: 'product-list' }
          },
        ]
      },
    
    ]
  },
  
  // {
  //   path: '/plate1',
  //   component: Layout,
  //   name: 'plate',
  //   redirect: '/plate/list',
  //   meta: { title: '活动类', icon: 'plate' },
  //   children: [
  //     {
  //       path: 'list',
  //       name: 'plateList',
  //       component: () => import('@/views/plate/list'),
  //       meta: { title: '板块列表', icon: 'plate-list' }
  //     }
  //   ]
  // },
  //   {
  //   path: '/plate',
  //   component: Layout,
  //   name: 'plate',
  //   redirect: '/plate/list',
  //   meta: {title: '板块通知管理', icon: 'plate'},
  //   children: [
  //     {
  //       path: 'list',
  //       name: 'plateList',
  //       component: () => import('@/views/plate/list'),
  //       meta: {title: '板块列表', icon: 'plate-list'}
  //     }
  //   ]
  // },
  {
    path: '/pmsint',
    component: Layout,
    redirect: '/pmsint/product?type=2',
    name: 'pmsint',
    meta: { title: '商品分类', icon: 'product' },
    hidden: true,

    children: [
      //     // {
      //     //   path: 'product/2',
      //     //   name: 'product',
      //     //   component: () => import('@/views/pms/product/index'),
      //     //   meta: {title: '商品列表', icon: 'product-list'},
      //     //   props: (route) => ({ type: route.query.type || 2 })
      //     // },
      //     //   {
      //     //     path: 'addProduct',
      //     //     name: 'addProduct',
      //     //     component: () => import('@/views/pms/product/add'),
      //     //     meta: {title: '添加商品', icon: 'product-add'},
      //     //     props: (route) => ({ type: route.query.type || 2 })

      //     //   },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: { title: '商品分类', icon: 'product-cate' },
        hidden: true

      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: { title: '添加商品分类' },
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: { title: '修改商品分类' },
        hidden: true
      },
    ]
  },
  {
    path: '/pmsaint',
    component: Layout,
    redirect: '/pmsint/product?type=3',
    name: 'pmsaint',
    meta: { title: '景区', icon: 'product' },
    children: [{
      path: 'product/3',
      name: 'product',
      component: () => import('@/views/pmsaint/product/index'),
      meta: { title: '产品品列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 3 })
    },
    {
      path: 'order/3',
      name: 'order',
      component: () => import('@/views/pmsaint/order/index'),
      meta: { title: '订单列表', icon: 'order-list' },
      props: (route) => ({ type: route.query.type || 3 })
    },
    {
      path: 'money_order_jq',
      name: 'money_order_jq',
      component: () => import('@/views/pmsaint/order/money_order'),
      meta: { title: '对账中心', icon: 'product-list' }
    },
    // 
    {
      path: 'fk_jq',
      name: 'fk_jq',
      component: () => import('@/views/feed/kf'),
      props: (route) => ({ type: '666666' }),

      meta: { title: '饲料客服列表', icon: 'product-list' }
    },
    {
      path: 'money_invoice_jq',
      name: 'money_invoice_jq',
      component: () => import('@/views/pmsaint/order/money_invoice'),
      meta: { title: '开票列表', icon: 'product-list' }
    },
    {
      path: 'orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/pmsaint/order/orderDetail'),
      meta: { title: '订单详情' },
      hidden: true
    },
    {
      path: 'updateProduct',
      name: 'updateProduct',
      // component: () => import('@/views/pms/product/scenic_update'),
      component: () => import('@/views/pmsaint/product/update'), // 实际使用组件的位置

      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },
    ]
  },
  {
    path: '/gds',
    component: Layout,
    redirect: '/gds/product?type=4',
    name: 'gds',
    meta: { title: '酒店', icon: 'gds' },
    children: [{
      path: 'product/4',
      name: 'product',
      component: () => import('@/views/gds/product/index'),
      meta: { title: '产品品列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 4 })
    },
    {
      path: 'order/3',
      name: 'order',
      component: () => import('@/views/gds/order/index'),
      meta: { title: '订单列表', icon: 'order-list' },
      props: (route) => ({ type: route.query.type || 4 })
    },
    {
      path: 'orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/gds/order/orderDetail'),
      meta: { title: '订单详情' },
      hidden: true
    },
    {
      path: 'updateProduct',
      name: 'updateProduct',
      // component: () => import('@/views/pms/product/scenic_update'),
      component: () => import('@/views/gds/product/update'), // 实际使用组件的位置

      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },
    ]
  },
  {
    path: '/guardi',
    component: Layout,
    redirect: '/guardi/product?type=6',
    name: 'guardi',
    meta: { title: '餐饮', icon: 'guardi' },
    children: [{
      path: 'product/4',
      name: 'product',
      component: () => import('@/views/guardi/product/index'),
      meta: { title: '产品品列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 6 })
    },
    {
      path: 'order/3',
      name: 'order',
      component: () => import('@/views/guardi/order/index'),
      meta: { title: '订单列表', icon: 'order-list' },
      props: (route) => ({ type: route.query.type || 6 })
    },
    {
      path: 'orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/guardi/order/orderDetail'),
      meta: { title: '订单详情' },
      hidden: true
    },
    {
      path: 'updateProduct',
      name: 'updateProduct',
      // component: () => import('@/views/pms/product/scenic_update'),
      component: () => import('@/views/guardi/product/update'), // 实际使用组件的位置

      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },
      // {
      //   path: 'wallet',
      //   name: 'WalletList',
      //   component: () => import('@/views/catering/wallet-list'),
      //   meta: { title: '钱包管理', icon: 'wallet' },
      //   props: (route) => ({ type:5 })

      // }
    ]
  },
  // 钱包管理
  // {
  //   path: '/wallet',
  //   component: Layout,
  //   redirect: '/wallet/list',
  //   name: 'wallenamet',
  //   meta: { title: '钱包管理', icon: 'wallet' },
  //   children: [
  //     {
  //       path: 'list',
  //       name: 'WalletList',
  //       component: () => import('@/views/catering/wallet-list'),
  //       meta: { title: '餐饮钱包管理', icon: 'wallet-list' },
  //       props: (route) => ({ type: 5 })
  //     },
  //     // 1-长城钱包 2-兴芮钱包 3-文库钱包 
  //     {
  //       path: 'list-cc',
  //       name: 'WalletListgwm',
  //       component: () => import('@/views/catering/wallet-list'),
  //       meta: { title: '长城钱包管理', icon: 'wallet-list' },
  //       props: (route) => ({ type: 1 })
  //     },
  //     {
  //       path: 'list-xr',
  //       name: 'WalletListxr',
  //       component: () => import('@/views/catering/wallet-list'),
  //       meta: { title: '兴芮钱包管理', icon: 'wallet-list' },
  //       props: (route) => ({ type: 2 })
  //     }, {
  //       path: 'list-wl',
  //       name: 'WalletListwl',
  //       component: () => import('@/views/catering/wallet-list'),
  //       meta: { title: '文旅钱包管理', icon: 'wallet-list' },
  //       props: (route) => ({ type: 3 })
  //     },
  //   ]
  // },

  {
    path: '/physical',
    component: Layout,
    redirect: '/physical/product?type=6',
    name: 'physical',
    meta: { title: '餐饮', icon: 'physical' },
    children: [{

      path: 'product/4',
      name: 'product',
      component: () => import('@/views/physical/product/index'),
      meta: { title: '产品品列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 8 })
    },
    {
      path: 'order/3',
      name: 'order',
      component: () => import('@/views/physical/order/index'),
      meta: { title: '订单列表', icon: 'order-list' },
      props: (route) => ({ type: route.query.type || 8 })
    },
    {
      path: 'fk_yy',
      name: 'fk_yy',
      component: () => import('@/views/feed/kf'),
      props: (route) => ({ type: '8888888888' }),

      meta: { title: '客服列表', icon: 'product-list' }
    },
    {
      path: 'orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/physical/order/orderDetail'),
      meta: { title: '订单详情' },
      hidden: true
    },
    {
      path: 'updateProduct',
      name: 'updateProduct',
      // component: () => import('@/views/pms/product/scenic_update'),
      component: () => import('@/views/physical/product/update'), // 实际使用组件的位置

      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'addProduct',
      name: 'addProduct',
      component: () => import('@/views/physical/product/add'),
      meta: { title: '添加商品', icon: 'product-add' },
      props: (route) => ({ type: route.query.type || 2 })

    },
    ]
  },
  {
    path: '/wine',
    component: Layout,
    redirect: '/wine/product',
    name: 'wine',
    meta: { title: '酒业商品', icon: 'physical' },
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/wine/product/index'),
      meta: { title: '商品列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 1 })

    },
    {
      path: 'fk_wine',
      name: 'fk_wine',
      component: () => import('@/views/feed/kf'),
      props: (route) => ({ type: '999999999999999999999' }),

      meta: { title: '酒业客服列表', icon: 'product-list' }
    },
    {
      path: 'updateProduct',
      name: 'updateProduct',
      component: () => import('@/views/pms/product/update'),
      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'order',
      name: 'wineorder',
      component: () => import('@/views/wine/order/index'),
      meta: { title: '订单列表', icon: 'product-list' }
    },
    {
      path: 'appWineOrder',
      name: 'appWineOrder',
      component: () => import('@/views/pms/appOrder/index'),
      meta: { title: '订单列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 1 })

    },
    {
      path: 'orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/wine/order/orderDetail'),
      meta: { title: '订单详情' },
      hidden: true
    },
    {
      path: 'money_order_jy',
      name: 'money_order_jy',
      component: () => import('@/views/wine/order/money_order'),
      meta: { title: '对账中心', icon: 'product-list' }
    },
    {
      path: 'money_invoice_jy',
      name: 'money_invoice_jy',
      component: () => import('@/views/wine/order/money_invoice'),
      meta: { title: '开票列表', icon: 'product-list' }
    },
    {
      path: 'deliverOrderList',
      name: 'deliverOrderList',
      component: () => import('@/views/feed/order/deliverOrderList'),
      meta: { title: '发货列表' },
      hidden: true
    },
    {
      path: 'member',
      name: 'wineMemberGrade',
      component: () => import('@/views/wine/member/index'),
      meta: { title: '会员等级管理', icon: 'product-list' }
    },

    {
      path: 'giftPromotionRules',
      name: 'giftPromotionRules',
      component: () => import('@/views/wine/gift/index'),
      meta: { title: '送礼规则管理', icon: 'product-list' }
    },
    {
      path: 'memberProduct',
      name: 'memberProduct',
      component: () => import('@/views/wine/memberproduct/index'),
      meta: { title: '会员日商品管理', icon: 'product-list' }
    },
    {
      path: 'memberDay',
      name: 'memberDay',
      component: () => import('@/views/wine/memberday/index'),
      meta: { title: '会员日设置', icon: 'product-list' }
    },
    {
      path: 'memberList',
      name: 'wineMemberList',
      component: () => import('@/views/wine/member/listmember'),
      meta: { title: '会员列表', icon: 'product-list' }
    },
    {
      path: 'membertotle',
      name: 'membertotle',
      component: () => import('@/views/wine/membertotle/index'),
      meta: { title: '用户列表查询', icon: 'product-list' }
    },
    {
      path: 'winOrder',
      name: 'winOrder',
      component: () => import('@/views/wine/winOrder/index'),
      meta: { title: '消费记录', icon: 'product-list' },
      hidden: true
    },
    {
      path: 'winOrder/:uid',
      name: 'winOrderWithUid',
      component: () => import('@/views/wine/winOrder/index'),
      meta: { title: '消费记录', icon: 'product-list' },
      hidden: true
    },
    {
      path: 'commission',
      name: 'commission',
      component: () => import('@/views/wine/winOrder/commission'),
      meta: { title: '佣金流水', icon: 'product-list' }
    },
    {
      path: 'BidActivityList',
      name: 'BidActivityList',
      component: () => import('@/views/bindactivey/index'),
      meta: { title: '竞价活动列表', icon: 'el-icon-s-order' }
    },
    {
      path: 'winepointsProduct',
      name: 'winepointsProduct',
      component: () => import('@/views/wine/points/product/index'),
      meta: { title: '酒业商品管理', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 1 })
    },
    {
      path: 'winepointsOrder',
      name: 'winepointsOrder',
      component: () => import('@/views/wine/points/order/index'),
      meta: { title: '酒业订单管理', icon: 'order-list' },
      props: (route) => ({ type: route.query.type || 1 })
    },
    {
      path: 'wineactivity',
      name: 'wineluckActivity',
      component: () => import('@/views/wine/luck/index.vue'),
      meta: { title: '抽奖活动管理', icon: 'gift' }
    },
    {
      path: 'winesalesProduct',
      name: 'winesalesProduct',
      component: () => import('@/views/wine/sales/index'),
      meta: { title: '酒业商品佣金管理', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 1 })
    },
    {
      path: 'competition',
      name: 'wineCompetition',
      component: () => import('@/views/wine/competition/index'),
      meta: { title: '酒业活动管理', icon: 'product-list' }
    },
    {
      path: 'competition/add',
      name: 'addWineCompetition',
      component: () => import('@/views/wine/competition/add'),
      meta: { title: '添加活动', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'competition/update',
      name: 'updateWineCompetition',
      component: () => import('@/views/wine/competition/update'),
      meta: { title: '编辑活动', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'competition/detail',
      name: 'wineCompetitionDetail',
      component: () => import('@/views/wine/competition/detail'),
      meta: { title: '活动详情', icon: 'product-list' },
      hidden: true
    },
    {
      path: 'competition/ranking',
      name: 'wineCompetitionRanking',
      component: () => import('@/views/wine/competition/rankingList'),
      meta: { title: '竞赛报名排名', icon: 'product-list' },
      hidden: true
    },
    {
      path: 'competition/ranking/detail',
      name: 'wineCompetitionRankingDetail',
      component: () => import('@/views/wine/competition/rankingDetail'),
      meta: { title: '报名排名详情', icon: 'product-list' },
      hidden: true
    },
    {
      path: 'bartender',
      name: 'bartender',
      component: () => import('@/views/wine/bartender/index'),
      meta: { title: '调酒师管理', icon: 'product-list' }
    },
    {
      path: 'bartender/add',
      name: 'addBartender',
      component: () => import('@/views/wine/bartender/add'),
      meta: { title: '添加调酒师', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'bartender/update',
      name: 'updateBartender',
      component: () => import('@/views/wine/bartender/update'),
      meta: { title: '编辑调酒师', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'distributionGradeConfig',
      name: 'distributionGradeConfig',
      component: () => import('@/views/wine/config/DistributionGradeConfigList'),
      meta: { title: '分销等级配置管理', icon: 'product-list' }
    },
    {
      path: 'reorderMonth',
      name: 'reorderMonth',
      component: () => import('@/views/wine/ReorderMonth/index'),
      meta: { title: '商品复购月统计', icon: 'product-list' }
      },
      {
        path: '/statistics',
        component: Layout,
        name: 'statistics',
        redirect: '/statistics/member',
        meta: { title: '统计分析', icon: 'el-icon-data-line' },
        children: [
          {
            path: 'member',
            name: 'MemberStatistics',
            component: () => import('@/views/statistics/index'),
            meta: { title: '会员增长统计', icon: 'el-icon-user' }
          },
          {
            path: 'consumption',
            name: 'ConsumptionStatistics',
            component: () => import('@/views/statistics/consumption'),
            meta: { title: '消费统计', icon: 'el-icon-shopping-cart-2' }
          }
        ]
      },
    // {
    //   path: 'productCate',
    //   name: 'productCate',
    //   component: () => import('@/views/pms/productCate/index'),
    //   meta: {title: '商品分类', icon: 'product-cate'}
    // },
    {
      path: 'addProductCate',
      name: 'addProductCate',
      component: () => import('@/views/pms/productCate/add'),
      meta: { title: '添加商品分类' },
      hidden: true
    },
    {
      path: 'updateProductCate',
      name: 'updateProductCate',
      component: () => import('@/views/pms/productCate/update'),
      meta: { title: '修改商品分类' },
      hidden: true
    },

    // {
    //   path: 'productAttr',
    //   name: 'productAttr',
    //   component: () => import('@/views/pms/productAttr/index'),
    //   meta: {title: '商品类型', icon: 'product-attr'}
    // },
    // {
    //   path: 'productAttrList',
    //   name: 'productAttrList',
    //   component: () => import('@/views/pms/productAttr/productAttrList'),
    //   meta: {title: '商品属性列表'},
    //   hidden: true
    // },
    {
      path: 'addProductAttr',
      name: 'addProductAttr',
      component: () => import('@/views/pms/productAttr/addProductAttr'),
      meta: { title: '添加商品属性' },
      hidden: true
    },
    {
      path: 'updateProductAttr',
      name: 'updateProductAttr',
      component: () => import('@/views/pms/productAttr/updateProductAttr'),
      meta: { title: '修改商品属性' },
      hidden: true
    },
    // {
    //   path: 'brand',
    //   name: 'brand',
    //   component: () => import('@/views/pms/brand/index'),
    //   meta: {title: '品牌管理', icon: 'product-brand'}
    // },
    {
      path: 'addBrand',
      name: 'addBrand',
      component: () => import('@/views/pms/brand/add'),
      meta: { title: '添加品牌' },
      hidden: true
    },
    {
      path: 'updateBrand',
      name: 'updateBrand',
      component: () => import('@/views/pms/brand/update'),
      meta: { title: '编辑品牌' },
      hidden: true
    }
    ]
  },

  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: { title: '农牧', icon: 'product' },
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: { title: '商品列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 5 })
    },

    {
      path: 'updateProduct',
      name: 'updateProduct',
      component: () => import('@/views/pms/product/update'),
      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'order',
      name: 'order',
      component: () => import('@/views/pms/order/index'),
      meta: { title: '订单列表', icon: 'product-list' }
    },
    {
      path: 'pmsAppOrder',
      name: 'pmsAppOrder',
      component: () => import('@/views/pms/appOrder/index'),
      meta: { title: '订单列表', icon: 'app-order-list' },
      props: (route) => ({ type: route.query.type || 5 })

    },
    {
      path: 'fk_nm',
      name: 'fk_nm',
      component: () => import('@/views/feed/kf'),
      props: (route) => ({ type: '5555555555' }),

      meta: { title: '农牧客服列表', icon: 'product-list' }
    },
    {
      path: 'money_order_nm',
      name: 'money_order_nm',
      component: () => import('@/views/pms/order/money_order'),
      meta: { title: '对账中心', icon: 'product-list' }
    },
    {
      path: 'orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/pms/order/orderDetail'),
      meta: { title: '订单详情' },
      hidden: true
    },
    ]
  },
  {
    path: '/feed',
    component: Layout,
    redirect: '/feed/product',
    name: 'feed',
    meta: { title: '饲料', icon: 'product' },
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/feed/product/index'),
      meta: { title: '商品列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 7 })

    },

    {
      path: 'order',
      name: 'order',
      component: () => import('@/views/feed/order/index'),
      meta: { title: '订单列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 7 })
    },
    {
      path: 'appFeedOrder',
      name: 'appFeedOrder',
      component: () => import('@/views/pms/appOrder/index'),
      meta: { title: '饲料app订单列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 7 })
    },
    {
      path: 'money_order',
      name: 'money_order',
      component: () => import('@/views/feed/order/money_order'),
      meta: { title: '对账中心', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 7 })
    },
    {
      path: 'money_invoice_feed',
      name: 'money_invoice_feed',
      component: () => import('@/views/feed/order/money_invoice'),
      meta: { title: '开票列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 7 })
    },
    {
      path: 'fk_feed',
      name: 'fk_feed',
      component: () => import('@/views/feed/kf'),
      props: (route) => ({ type: '7777777777' }),

      meta: { title: '饲料客服列表', icon: 'product-list' }
    },

    {
      path: 'orderDetail',
      name: 'orderDetail',
      component: () => import('@/views/feed/order/orderDetail'),
      meta: { title: '订单详情' },
      hidden: true
    },
    {
      path: 'deliverOrderList',
      name: 'deliverOrderList',
      component: () => import('@/views/feed/order/deliverOrderList'),
      meta: { title: '发货列表' },
      hidden: true
    },
    {
      path: 'addProduct',
      hidden: true,
      name: 'addProduct',
      component: () => import('@/views/feed/product/add'),
      meta: { title: '添加商品', icon: 'product-add' }
    },
    {
      path: 'updateProduct',
      name: 'updateProduct',
      component: () => import('@/views/feed/product/update'),
      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },


    ]
  },
  // {
  //   path: '/chicken',
  //   component: Layout,
  //   redirect: '/chicken/index',
  //   name: 'chicken',
  //   meta: { title: '饲料任务管理', icon: 'el-icon-s-help' },
  //   children: [{
  //     path: 'index',
  //     name: 'chickenIndex',
  //     component: () => import('@/views/chicken/index'),
  //     meta: { title: '饲料规则管理', icon: 'el-icon-document' }
  //   },
  //   {
  //     path: 'claim-record',
  //     name: 'chickenClaimRecord',
  //     component: () => import('@/views/chicken/claimRecord'),
  //     meta: { title: '领取记录', icon: 'el-icon-document' }
  //   },
  //   {
  //     path: "linkSetting",
  //     name: "LinkSetting",
  //     component: () => import("@/views/chicken/linkSetting"),
  //     meta: { title: "今日特惠", icon: "el-icon-link" }
  //   },
  //   {
  //     path: 'test',
  //     name: 'chickenTest',
  //     component: () => import('@/views/chicken/test'),
  //     meta: { title: '功能测试', icon: 'el-icon-s-operation' },
  //     hidden: true
  //   },
  //   {
  //     path: 'router-test',
  //     name: 'chickenRouterTest',
  //     component: () => import('@/views/chicken/router-test'),
  //     meta: { title: '路由测试', icon: 'el-icon-s-operation' },
  //     hidden: true
  //   }
  //   ]
  // },
  // {
  //   path: '/plant',
  //   component: Layout,
  //   redirect: '/plant/index',
  //   name: 'plant',
  //   meta: { title: '养殖饲料奖励管理', icon: 'el-icon-s-help' },
  //   children: [{
  //     path: 'index',
  //     name: 'plantIndex',
  //     component: () => import('@/views/plant/index'),
  //     meta: { title: '饲料规则管理', icon: 'el-icon-document' }
  //   },
  //   {
  //     path: 'userReward',
  //     name: 'plantUserReward',
  //     component: () => import('@/views/plant/userReward'),
  //     meta: { title: '用户奖励记录', icon: 'el-icon-user' }
  //   }
  //   ]
  // },
  {
    path: '/vegetable',
    component: Layout,
    redirect: '/vegetable/product',
    name: 'vegetable',
    meta: { title: '果蔬', icon: 'product' },
    children: [{
      path: 'vegetablelist',
      name: 'vegetablelist',
      component: () => import('@/views/feed/product/index'),
      meta: { title: '商品列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 9 })

    },

    {
      path: 'vegetableorder',
      name: 'vegetableorder',
      component: () => import('@/views/feed/order/index'),
      meta: { title: '订单列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 9 })

    },
    {
      path: 'appVegetableOrder',
      name: 'appVegetableOrder',
      component: () => import('@/views/pms/appOrder/index'),
      meta: { title: '订单列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 9 })
    },
    {
      path: 'money_order_vegetable',
      name: 'money_order_vegetable',
      component: () => import('@/views/feed/order/money_order'),
      meta: { title: '对账中心', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 9 })

    },
    {
      path: 'money_invoice_vegetable',
      name: 'money_invoice_vegetable',
      component: () => import('@/views/feed/order/money_invoice'),
      meta: { title: '开票列表', icon: 'product-list' },
      props: (route) => ({ type: route.query.type || 9 })

    },
    {
      path: 'fk_vegetable',
      name: 'fk_vegetable',
      component: () => import('@/views/feed/kf'),
      props: (route) => ({ type: '9999999' }),

      meta: { title: '饲料客服列表', icon: 'product-list' }
    },

    {
      path: 'vegetableorderDetail',
      name: 'vegetableorderDetail',
      component: () => import('@/views/feed/order/orderDetail'),
      meta: { title: '订单详情' },
      hidden: true
    },
    {
      path: 'deliverOrderList_vegetable',
      name: 'deliverOrderList_vegetable',
      component: () => import('@/views/feed/order/deliverOrderList'),
      meta: { title: '发货列表' },
      hidden: true
    },
    {
      path: 'addProduct_vegetable',
      hidden: true,
      name: 'addProduct_vegetable',
      component: () => import('@/views/feed/product/add'),
      meta: { title: '添加商品', icon: 'product-add' }
    },
    {
      path: 'updateProduct_vegetable',
      name: 'updateProduct_vegetable',
      component: () => import('@/views/feed/product/update'),
      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },


    ]
  },
  // {
  //   path: '/luck',
  //   component: Layout,
  //   name: 'luck',
  //   meta: { title: '抽奖活动管理', icon: 'gift' },
  //   children: [
  //     {
  //       path: 'activity',
  //       name: 'luckActivity',
  //       component: () => import('@/views/luck/index.vue'),
  //       meta: { title: '抽奖活动管理', icon: 'gift' }
  //     }
  //   ]
  // },

  // {
  //   path: '/activity',
  //   component: Layout,
  //   name: 'activity',
  //   redirect: '/activity/index',
  //   meta: { title: '营销活动商品管理', icon: 'product' },
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'marketingActivityProduct',
  //       component: () => import('@/views/activity/index'),
  //       meta: { title: '营销活动商品管理', icon: 'product-list' }
  //     },
  //     {
  //       path: 'activityManage',
  //       name: 'activityProductCombined',
  //       component: () => import('@/views/activity/activityManage'),
  //       meta: { title: '阶段活动管理', icon: 'gift' }
  //     },
  //     // bargain
  //     // unite
  //     {
  //       path: 'unite',
  //       name: 'unite',
  //       component: () => import('@/views/unite/index'),
  //       meta: { title: '联合活动管理', icon: 'gift' }
  //     }, {
  //       path: 'bargain',
  //       name: 'bargain',
  //       component: () => import('@/views/bargain/index'),
  //       meta: { title: '砍价活动管理', icon: 'gift' }
  //     },
  //     {
  //       path: 'order-manage',

  //       component: () => import('@/views/activity/ActivityOrderManage'),
  //       name: 'ActivityOrderManage',
  //       meta: { title: '活动订单管理', icon: 'order' }
  //     },
  //     {
  //       path: 'order-info',
  //       component: () => import('@/views/feed/order/orderDetail'),

  //       // component: () => import('@/views/activity/ActivityOrderInfo'),
  //       name: 'ActivityOrderInfo',
  //       meta: { title: '活动订单详情', icon: 'order' }
  //     },
  //     {
  //       path: 'activityTest',
  //       name: 'activityProductCombinedTest',
  //       component: () => import('@/views/activity/activityTest'),
  //       meta: { title: '活动管理测试', icon: 'test' },
  //       hidden: true
  //     },
  //     {
  //       path: 'buyingGroupPrice',
  //       name: 'buyingGroupPrice',
  //       component: () => import('@/views/activity/Buying/index'),
  //       meta: { title: '拼团价格管理', icon: 'gift' }
  //     },
  //     {
  //       path: 'buyingGroupParticipants',
  //       name: 'buyingGroupParticipants',
  //       component: () => import('@/views/buyingGroup/participants'),
  //       meta: { title: '拼团参团信息', icon: 'el-icon-s-custom' },
  //       hidden: true
  //     },
  //     {
  //       path: 'oneYuanActivityManage',
  //       name: 'oneYuanActivityManage',
  //       component: () => import('@/views/activity/oneYuanActivityManage'),
  //       meta: { title: '一元购活动管理', icon: 'gift' }
  //     },
  //     {
  //       path: 'addOneYuanActivity',
  //       name: 'addOneYuanActivity',
  //       component: () => import('@/views/activity/oneYuanActivityEdit'),
  //       meta: { title: '添加一元购活动', icon: 'edit' },
  //       hidden: true
  //     },
  //     {
  //       path: 'updateOneYuanActivity',
  //       name: 'updateOneYuanActivity',
  //       component: () => import('@/views/activity/oneYuanActivityEdit'),
  //       meta: { title: '编辑一元购活动', icon: 'edit' },
  //       hidden: true
  //     },
  //     {
  //       path: 'test',
  //       name: 'marketingActivityProductTest',
  //       component: () => import('@/views/activity/test'),
  //       meta: { title: '功能测试', icon: 'test' },
  //       hidden: true
  //     }
  //   ]
  // },
  // {
  //   path: '/comment',
  //   component: Layout,
  //   name: 'comment',
  //   redirect: '/comment/index',
  //   meta: { title: '评论管理', icon: 'el-icon-chat-dot-round' },
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'commentList',
  //       component: () => import('@/views/comment/index'),
  //       meta: { title: '评论列表', icon: 'el-icon-chat-line-round' }
  //     },
  //     {
  //       path: 'detail/:id',
  //       name: 'commentDetail',
  //       component: () => import('@/views/comment/detail'),
  //       meta: { title: '评论详情' },
  //       hidden: true
  //     },
  //     {
  //       path: 'test',
  //       name: 'commentTest',
  //       component: () => import('@/views/comment/test'),
  //       meta: { title: '功能测试' },
  //       hidden: true
  //     }
  //   ]
  // },
  // {
  //   path: '/score',
  //   component: Layout,
  //   name: 'score',
  //   redirect: '/score/scoreCategory',
  //   meta: { title: '对账管理', icon: 'product' },
  //   children: [
  //     {
  //       path: 'category',
  //       name: 'scoreCategory',
  //       component: () => import('@/views/score/index'),
  //       meta: { title: '分类汇总', icon: 'product-list' }
  //     },
  //     {
  //       path: 'list',
  //       name: 'scoreList',
  //       component: () => import('@/views/score/list'),
  //       meta: { title: '对账列表', icon: 'product-list' }
  //     },
  //     {
  //       path: 'scoreByCategory',
  //       name: 'scoreByCategory',
  //       component: () => import('@/views/kppoint/scoreByCategory'),
  //       meta: { title: '积分商城对账', icon: 'product-list' }
  //     },
  //   ]
  // },

  // {
  //   path: '/oms',
  //   component: Layout,

  //   name: 'oms',
  //       hidden:true,
  //   meta: {title: '订单', icon: 'order'},
  //   children: [
  //     {
  //       path: 'order',
  //       name: 'order',
  //         hidden:true,
  //       component: () => import('@/views/oms/order/index'),
  //       meta: {title: '订单列表', icon: 'product-list'}
  //     },
  //     {
  //       path: 'orderDetail',
  //       name: 'orderDetail',
  //       component: () => import('@/views/oms/order/orderDetail'),
  //       meta: {title: '订单详情'},
  //       hidden:true
  //     },
  //     {
  //       path: 'deliverOrderList',
  //       name: 'deliverOrderList',
  //       component: () => import('@/views/oms/order/deliverOrderList'),
  //       meta: {title: '发货列表'},
  //       hidden:true
  //     },
  //     {
  //       path: 'orderSetting',
  //       name: 'orderSetting',
  //       component: () => import('@/views/oms/order/setting'),
  //       meta: { title: '订单设置', icon: 'order-setting' },
  //       hidden:true,
  //     },
  //     {
  //       path: 'returnApply',
  //       name: 'returnApply',
  //       component: () => import('@/views/oms/apply/index'),
  //       meta: {title: '退货申请处理', icon: 'order-return'},
  //       hidden:true,
  //     },
  //     {
  //       path: 'returnReason',
  //       name: 'returnReason',
  //       component: () => import('@/views/oms/apply/reason'),
  //       meta: {title: '退货原因设置', icon: 'order-return-reason'},
  //       hidden:true,
  //     },
  //     {
  //       path: 'returnApplyDetail',
  //       name: 'returnApplyDetail',
  //       component: () => import('@/views/oms/apply/applyDetail'),
  //       meta: {title: '退货原因详情'},
  //       hidden:true
  //     }
  //   ]
  // },
  {
    path: '/member',
    component: Layout,
    name: 'member',
    redirect: '/member/list',
    meta: { title: '用户管理', icon: 'product' },
    children: [
      {
        path: 'list',
        name: 'memberList',
        component: () => import('@/views/member/list'),
        meta: { title: '用户列表', icon: 'product' }
      },
      {
        path: 'info',
        name: 'memberinfo',
        component: () => import('@/views/member/list/info'),
        meta: { title: '订单', icon: 'product-list' }
      },
    ]
  },
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: { title: '营销', icon: 'sms' },
    children: [
      {
        path: 'welfarequan',
        name: 'welfarequan',
        component: () => import('@/views/sms/welfarequan/welfarequan'),
        meta: { title: '文旅提货券模版', icon: 'sms-coupon' },
        props: (route) => ({ type: route.query.type || 3 }),

      },
      {
        path: 'jywelfarequan',
        name: 'jywelfarequan',
        component: () => import('@/views/sms/welfarequan/welfarequan'),
        meta: { title: '酒业提货券模版', icon: 'sms-coupon' },
        props: (route) => ({ type: route.query.type || 1 }),

      },
      {
        path: 'nmwelfarequan',
        name: 'nmwelfarequan',
        component: () => import('@/views/sms/welfarequan/welfarequan'),
        meta: { title: '农牧提货券模版', icon: 'sms-coupon' },
        props: (route) => ({ type: route.query.type || 5 }),

      },
      {
        path: 'slwelfarequan',
        name: 'slwelfarequan',
        component: () => import('@/views/sms/welfarequan/welfarequan'),
        meta: { title: '饲料提货券模版', icon: 'sms-coupon' },
        props: (route) => ({ type: route.query.type || 7 }),

      },
      {
        path: 'tjwelfarequan',
        name: 'tjwelfarequan',
        component: () => import('@/views/sms/welfarequan/welfarequan'),
        meta: { title: '体检提货券模版', icon: 'sms-coupon' },
        props: (route) => ({ type: route.query.type || 8 }),

      },
      {
        path: 'gswelfarequan',
        name: 'gswelfarequan',
        component: () => import('@/views/sms/welfarequan/welfarequan'),
        meta: { title: '果蔬提货券模版', icon: 'sms-coupon' },
        props: (route) => ({ type: route.query.type || 9 }),

      },
      {
        path: 'welfare',
        name: 'welfare',
        component: () => import('@/views/sms/welfare/index'),
        props: (route) => ({ type: route.query.type || 3 }),

        meta: { title: '福利列表', icon: 'sms-coupon' }
      },
      {
        path: 'welfarenm',
        name: 'welfarenm',
        component: () => import('@/views/sms/welfare/index'),
        props: (route) => ({ type: route.query.type || 5 }),

        meta: { title: '福利列表', icon: 'sms-coupon' }
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        props: (route) => ({ type: route.query.type || 1 }),

        meta: { title: '酒业优惠卷列表', icon: 'sms-coupon' }
      },
      {
        path: 'jqcoupon',
        name: 'jqcoupon',
        component: () => import('@/views/sms/coupon/index'),
        props: (route) => ({ type: 3 }),

        meta: { title: '酒业优惠卷列表', icon: 'sms-coupon' }
      },
      {
        path: 'pmscoupon',
        name: 'pmscoupon',
        component: () => import('@/views/sms/coupon/index'),
        props: (route) => ({ type: 5 }),

        meta: { title: '农牧优惠券列表', icon: 'sms-coupon' }
      },
      {
        path: 'cscoupon',
        name: 'cscoupon',
        component: () => import('@/views/sms/coupon/index'),
        props: (route) => ({ type: 6 }),

        meta: { title: '餐饮优惠券列表', icon: 'sms-coupon' }
      },
      {
        path: 'vegetablecoupon',
        name: 'vegetablecoupon',
        component: () => import('@/views/sms/coupon/index'),
        props: (route) => ({ type: 9 }),

        meta: { title: '果蔬优惠券列表', icon: 'sms-coupon' }
      },

      {
        path: 'feedcoupon',
        name: 'feedcoupon',
        component: () => import('@/views/sms/coupon/index'),
        props: (route) => ({ type: 7 }),

        meta: { title: '饲料优惠券列表', icon: 'sms-coupon' }
      },
      {
        path: 'orderFinishCoupon',
        name: 'orderFinishCoupon',
        component: () => import('@/views/sms/coupon/index'),
        props: (route) => ({ type: 99 }),

        meta: { title: '订单完成优惠券列表', icon: 'sms-coupon' }
      },
      {
        path: 'gscoupon',
        name: 'gscoupon',
        component: () => import('@/views/sms/coupon/index'),
        props: (route) => ({ type: 9 }),
        meta: { title: '果蔬优惠券列表', icon: 'sms-coupon' }
      },
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: { title: '秒杀活动列表', icon: 'sms-flash' }
      },
      // {
      //   path: 'flashSession',
      //   name: 'flashSession',
      //   component: () => import('@/views/sms/flash/sessionList'),
      //   meta: {title: '秒杀时间段列表'},
      //   hidden:true
      // },
      // {
      //   path: 'selectSession',
      //   name: 'selectSession',
      //   component: () => import('@/views/sms/flash/selectSessionList'),
      //   meta: {title: '秒杀时间段选择'},
      //   hidden:true
      // },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: { title: '秒杀商品列表' },
        hidden: true
      },
      // {
      //   path: 'coupon',
      //   name: 'coupon',
      //   component: () => import('@/views/sms/coupon/index'),
      //   meta: {title: '优惠券列表', icon: 'sms-coupon'}
      // },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: { title: '添加优惠券' },
        hidden: true,
        props: true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: { title: '修改优惠券' },
        hidden: true,
        props: true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: { title: '优惠券领取详情' },
        hidden: true
      },
      // {
      //   path: 'brand',
      //   name: 'homeBrand',
      //   component: () => import('@/views/sms/brand/index'),
      //   meta: {title: '品牌推荐', icon: 'product-brand'}
      // },
      {
        path: 'index',
        name: 'indexHot',
        component: () => import('@/views/sms/index/index'),
        meta: { title: '首页推荐', icon: 'sms-hot' },

      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: { title: '农牧推荐', icon: 'sms-new' }
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: { title: '酒业推荐', icon: 'sms-hot' }
      },
      {
        path: 'feedHot',
        name: 'feedHot',
        component: () => import('@/views/sms/feed/index'),
        meta: { title: '饲料推荐', icon: 'sms-hot' },
        props: (route) => ({ type: route.query.type || 7 })

      },
      {
        path: 'vegetableHot',
        name: 'vegetableHot',
        component: () => import('@/views/sms/vegetable/index'),
        meta: { title: '果蔬推荐', icon: 'sms-hot' },
        props: (route) => ({ type: 9 })
      },
      {
        path: 'physical',
        name: 'physicals',
        component: () => import('@/views/sms/physical/index'),
        meta: { title: '医院推荐', icon: 'sms-hot' }
      },

      // {
      //   path: 'subject',
      //   name: 'homeSubject',
      //   component: () => import('@/views/sms/subject/index'),
      //   meta: {title: '专题推荐', icon: 'sms-subject'}
      // },
      {
        path: 'advertiseindex',
        name: 'homeAdvertiseindex',
        component: () => import('@/views/sms/advertiseindex/index'),
        meta: { title: '首页广告列表', icon: 'sms-ad' },
        props: (route) => ({ type: route.query.type || 1 })

      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: { title: '酒业广告列表', icon: 'sms-ad' },
        props: (route) => ({ type: route.query.type || 3 })

      },
      {
        path: 'advertisew',
        name: 'homeAdvertisew',
        component: () => import('@/views/sms/advertisew/index'),
        meta: { title: '农牧广告列表', icon: 'sms-ad' },
        props: (route) => ({ type: route.query.type || 2 })

      },
      {
        path: 'advertisewfeed',
        name: 'homeAdvertisewfeed',
        component: () => import('@/views/sms/advertisewfeed/index'),
        meta: { title: '饲料广告列表', icon: 'sms-ad' },
        props: (route) => ({ type: route.query.type || 7 })

      },
      {
        path: 'advertisewfeed_vegetable',
        name: 'homeAdvertisewfeed_vegetable',
        component: () => import('@/views/sms/advertisewfeed/index'),
        meta: { title: '果蔬广告列表', icon: 'sms-ad' },
        props: (route) => ({ type: route.query.type || 9 })

      },
      {
        path: 'advertiseguardi',
        name: 'homeAdvertiseguardi',
        component: () => import('@/views/sms/advertiseguardi/index'),
        meta: { title: '文旅广告列表', icon: 'sms-ad' },
        props: (route) => ({ type: route.query.type || 1 })

      },
      {
        path: 'advertisewphysical',
        name: 'advertisewphysical',
        component: () => import('@/views/sms/advertisewphysical/index'),
        meta: { title: '医院广告列表', icon: 'sms-ad' },
        props: (route) => ({ type: route.query.type || 1 })

      },
      {
        path: 'updateAdvertisephysical',
        name: 'updateHomeAdvertisephysical',
        component: () => import('@/views/sms/advertisewphysical/update'),
        meta: { title: '编辑广告' },
        hidden: true
      },
      {
        path: 'addAdvertisephysical',
        name: 'addHomeAdvertisephysical',
        component: () => import('@/views/sms/advertisewphysical/add'),
        meta: { title: '添加广告' },
        hidden: true
      },
      {
        path: 'updateAdvertiseguardi',
        name: 'updateHomeAdvertiseguardi',
        component: () => import('@/views/sms/advertiseguardi/update'),
        meta: { title: '编辑广告' },
        hidden: true
      },
      {
        path: 'addAdvertisefeed',
        name: 'addHomeAdvertisefeed',
        component: () => import('@/views/sms/advertisewfeed/add'),
        meta: { title: '添加广告' },
        hidden: true
      },
      {
        path: 'addAdvertiseguardi',
        name: 'addHomeAdvertiseguardi',
        component: () => import('@/views/sms/advertiseguardi/add'),
        meta: { title: '添加广告' },
        hidden: true
      },
      {
        path: 'updateAdvertisefeed',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertisewfeed/update'),
        meta: { title: '编辑广告' },
        hidden: true
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: { title: '添加广告' },
        hidden: true
      },
      {
        path: 'addAdvertiseindex',
        name: 'addHomeAdvertiseindex',
        component: () => import('@/views/sms/advertiseindex/add'),
        meta: { title: '添加广告' },
        hidden: true
      },
      {
        path: 'addAdvertisew',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertisew/add'),
        meta: { title: '添加广告' },
        hidden: true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: { title: '编辑广告' },
        hidden: true
      },
      {
        path: 'updateAdvertiseindex',
        name: 'updateHomeAdvertiseindex',
        component: () => import('@/views/sms/advertiseindex/update'),
        meta: { title: '编辑广告' },
        hidden: true
      },
      {
        path: 'updateAdvertisew',
        name: 'updateHomeAdvertisew',
        component: () => import('@/views/sms/advertisew/update'),
        meta: { title: '编辑广告' },
        hidden: true
      },

    ]
  },
  {
    path: '/homes',
    component: Layout,
    redirect: '/homes/coupon',
    name: 'homes',
    meta: { title: '首页推荐', icon: 'sms' },
    children: [


      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/homes/new/index'),
        meta: { title: '农牧推荐', icon: 'sms-new' }
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/homes/hot/index'),
        meta: { title: '酒业推荐', icon: 'sms-hot' }
      },
      {
        path: 'feedHot',
        name: 'feedHot',
        component: () => import('@/views/homes/feed/index'),
        meta: { title: '饲料推荐', icon: 'sms-hot' }
      },
      {
        path: 'vegetable',
        name: 'vegetableHot2',
        component: () => import('@/views/homes/vegetable/index'),
        meta: { title: '果蔬推荐', icon: 'sms-hot' }
      },
      {
        path: 'physical',
        name: 'physicalHot',
        component: () => import('@/views/homes/physical/index'),
        meta: { title: '医院推荐', icon: 'sms-hot' }
      },
      {
        path: 'catering',
        name: 'cateringHot',
        component: () => import('@/views/homes/catering/index'),
        meta: { title: '餐饮推荐', icon: 'sms-hot' }
      },

      // {
      //   path: 'subject',
      //   name: 'homeSubject',
      //   component: () => import('@/views/sms/subject/index'),
      //   meta: {title: '专题推荐', icon: 'sms-subject'}
      // },

    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: { title: '权限', icon: 'ums' },
    children: [
      {
        path: 'feightTemplate',
        name: 'feightTemplate',
        component: () => import('@/views/pms/feightTemplate/index'),
        meta: { title: '运费模板', icon: 'product-list' }
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: 'ums-admin' }
      },
      {
        path: 'admins',
        name: 'admins',
        component: () => import('@/views/ums/admin/indexs'),
        meta: { title: '用户列表', icon: 'ums-admin' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: 'ums-role' }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: { title: '分配菜单' },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: { title: '分配资源' },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: 'ums-menu' }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: { title: '添加菜单' },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: { title: '资源列表', icon: 'ums-resource' }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: { title: '资源分类' },
        hidden: true
      },
      {
        path: 'membershipLevel',
        name: 'membershipLevel',
        component: () => import('@/views/ums/membershipLevel/index'),
        meta: { title: '会员等级管理', icon: 'ums-member' }
      }
    ]
  },
  // {
  //   path: '/system',
  //   component: Layout,
  //   redirect: '/system/adminLog',
  //   name: 'system',
  //   meta: { title: '系统管理', icon: 'el-icon-setting' },
  //   children: [
  //     {
  //       path: 'adminLog',
  //       name: 'adminLog',
  //       component: () => import('@/views/system/adminLog/index'),
  //       meta: { title: '操作日志', icon: 'el-icon-document' }
  //     },
  //     {
  //       path: 'log',
  //       name: 'log',
  //       component: () => import('@/views/log/index.vue'),
  //       meta: { title: '操作日志', icon: 'el-icon-document' }
  //     }
  //   ]
  // },
  // {
  //   path: '/points',
  //   component: Layout,
  //   redirect: '/points/product',
  //   name: 'points',
  //   meta: { title: '积分商城', icon: 'product' },
  //   children: [
  //     {
  //       path: 'zbproduct',
  //       name: 'zbpointsProduct',
  //       component: () => import('@/views/points/product/index'),
  //       meta: { title: '总部商品管理', icon: 'product-list' },
  //       props: (route) => ({ type: route.query.type || 11 })
  //     },
  //     {
  //       path: 'pjproduct',
  //       name: 'pjpointsProduct',
  //       component: () => import('@/views/points/product/index'),
  //       meta: { title: '平价商品管理', icon: 'product-list' },
  //       props: (route) => ({ type: route.query.type || 12 })
  //     },
  //     {
  //       path: 'product',
  //       name: 'pointsProduct',
  //       component: () => import('@/views/points/product/index'),
  //       meta: { title: '酒业商品管理', icon: 'product-list' },
  //       props: (route) => ({ type: route.query.type || 1 })
  //     }, {
  //       path: 'jqproduct',
  //       name: 'jqpointsProduct',
  //       component: () => import('@/views/points/product/index'),
  //       meta: { title: '景区商品管理', icon: 'product-list' },
  //       props: (route) => ({ type: route.query.type || 3 })
  //     }, {
  //       path: 'nmproduct',
  //       name: 'nmpointsProduct',
  //       component: () => import('@/views/points/product/index'),
  //       meta: { title: '农贸商品管理', icon: 'product-list' },
  //       props: (route) => ({ type: route.query.type || 5 })
  //     }, {
  //       path: 'slproduct',
  //       name: 'slpointsProduct',
  //       component: () => import('@/views/points/product/index'),
  //       meta: { title: '饲料商品管理', icon: 'product-list' },
  //       props: (route) => ({ type: route.query.type || 7 })
  //     }, {
  //       path: 'tjproduct',
  //       name: 'tjpointsProduct',
  //       component: () => import('@/views/points/product/index'),
  //       meta: { title: '体检商品管理', icon: 'product-list' },
  //       props: (route) => ({ type: route.query.type || 8 })
  //     }, {
  //       path: 'order',
  //       name: 'pointsOrder',
  //       component: () => import('@/views/points/order/index'),
  //       meta: { title: '酒业订单管理', icon: 'order-list' },
  //       props: (route) => ({ type: route.query.type || 1 })

  //     }, {
  //       path: 'jqorder',
  //       name: 'jqpointsOrder',
  //       component: () => import('@/views/points/order/index'),
  //       meta: { title: '景区订单管理', icon: 'order-list' },
  //       props: (route) => ({ type: route.query.type || 3 })
  //     }, {
  //       path: 'nmorder',
  //       name: 'nmpointsOrder',
  //       component: () => import('@/views/points/order/index'),
  //       meta: { title: '农贸订单管理', icon: 'order-list' },
  //       props: (route) => ({ type: route.query.type || 5 })
  //     }, {
  //       path: 'slorder',
  //       name: 'slpointsOrder',
  //       component: () => import('@/views/points/order/index'),
  //       meta: { title: '饲料订单管理', icon: 'order-list' },
  //       props: (route) => ({ type: route.query.type || 7 })
  //     }, {
  //       path: 'tjorder',
  //       name: 'tjpointsOrder',
  //       component: () => import('@/views/points/order/index'),
  //       meta: { title: '体检订单管理', icon: 'order-list' },
  //       props: (route) => ({ type: route.query.type || 8 })
  //     }, {
  //       path: 'zborder',
  //       name: 'zbpointsOrder',
  //       component: () => import('@/views/points/order/index'),
  //       meta: { title: '总部订单管理', icon: 'order-list' },
  //       props: (route) => ({ type: route.query.type || 11 })
  //     },
  //     {
  //       path: 'pjorder',
  //       name: 'pjpointsOrder',
  //       component: () => import('@/views/points/order/index'),
  //       meta: { title: '平价订单管理', icon: 'order-list' },
  //       props: (route) => ({ type: route.query.type || 12 })
  //     }]
  // },
  // {
  //   path: '/sales',
  //   component: Layout,
  //   redirect: '/sales/index',
  //   name: 'sales',
  //   meta: { title: '分销管理', icon: 'product' },
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'productCommission',
  //       component: () => import('@/views/sales/index'),
  //       meta: { title: '商品分销设置', icon: 'product-list' }
  //     }
  //   ]
  // },
  // {
  //   path: '/pickupPoint',
  //   component: Layout,
  //   redirect: '/pickupPoint/index',
  //   name: 'pickupPoint',
  //   hidden: true,
  //   meta: { title: '自提点管理', icon: 'product' },
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'pickupPointIndex',
  //       component: () => import('@/views/pickupPoint/index'),
  //       meta: { title: '自提点管理', icon: 'product-list' }
  //     }
  //   ]
  // },

  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js